import { Outlet, useLocation } from "@tanstack/react-router";
import { AppSidebar } from "@/components/app-sidebar";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

function useSectionTitle(): string {
  const { pathname } = useLocation();
  if (pathname.startsWith("/ingestion")) return "Ingestion";
  if (pathname.startsWith("/novaut")) return "Novaut";
  if (pathname.startsWith("/dashboard")) return "Overview";
  return "Overview";
}

export function DashboardLayout() {
  const title = useSectionTitle();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b border-border bg-background/80 px-4 backdrop-blur">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-1 h-5" />
          <h1 className="text-base font-bold tracking-tight">{title}</h1>
        </header>
        <div className="flex-1 p-4 sm:p-6">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
